import { apiClient } from './apiClient';

export const orderService = {
  async createOrder(amount) {
    return apiClient.post('/order/create', { amount });
  },

  async updateOrder(updatePayload) {
    return apiClient.post('/order/update', updatePayload);
  },
};
